var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.7872 32.2917H5.20801V83.3334C5.20801 86.3709 6.41634 89.2875 8.56218 91.4375C10.7131 93.5842 13.6275 94.7904 16.6663 94.7917C16.6663 94.7917 84.0664 94.775 84.4288 94.7375L77.1038 87.4167C73.1376 89.586 68.6753 90.6861 64.1552 90.609C59.6352 90.5319 55.213 89.2802 51.323 86.977C47.4331 84.6737 44.2093 81.398 41.9683 77.4719C39.7274 73.5457 38.5464 69.1041 38.5413 64.5834C38.5413 50.2125 50.2122 38.5417 64.583 38.5417C69.1037 38.5467 73.5453 39.7277 77.4715 41.9687C81.3977 44.2096 84.6733 47.4335 86.9766 51.3234C89.2799 55.2133 90.5315 59.6356 90.6087 64.1556C90.6858 68.6756 89.5856 73.138 87.4163 77.1042L94.7372 84.4292C94.7663 84.15 94.783 53.6209 94.7872 32.2917ZM5.20801 26.0417H94.7914V16.6667C94.7914 13.6292 93.583 10.7125 91.4372 8.56254C89.2863 6.41586 86.3719 5.20965 83.333 5.20837H16.6663C13.6288 5.20837 10.7122 6.41671 8.56218 8.56254C6.41549 10.7135 5.20928 13.6278 5.20801 16.6667V26.0417ZM18.7497 19.7917H22.9163C23.7451 19.7917 24.54 19.4625 25.1261 18.8764C25.7121 18.2904 26.0413 17.4955 26.0413 16.6667C26.0413 15.8379 25.7121 15.043 25.1261 14.457C24.54 13.8709 23.7451 13.5417 22.9163 13.5417H18.7497C17.9209 13.5417 17.126 13.8709 16.54 14.457C15.9539 15.043 15.6247 15.8379 15.6247 16.6667C15.6247 17.4955 15.9539 18.2904 16.54 18.8764C17.126 19.4625 17.9209 19.7917 18.7497 19.7917ZM33.333 19.7917H37.4997C38.3285 19.7917 39.1233 19.4625 39.7094 18.8764C40.2954 18.2904 40.6247 17.4955 40.6247 16.6667C40.6247 15.8379 40.2954 15.043 39.7094 14.457C39.1233 13.8709 38.3285 13.5417 37.4997 13.5417H33.333C32.5042 13.5417 31.7094 13.8709 31.1233 14.457C30.5372 15.043 30.208 15.8379 30.208 16.6667C30.208 17.4955 30.5372 18.2904 31.1233 18.8764C31.7094 19.4625 32.5042 19.7917 33.333 19.7917ZM47.9163 19.7917H52.083C52.9118 19.7917 53.7067 19.4625 54.2927 18.8764C54.8788 18.2904 55.208 17.4955 55.208 16.6667C55.208 15.8379 54.8788 15.043 54.2927 14.457C53.7067 13.8709 52.9118 13.5417 52.083 13.5417H47.9163C47.0875 13.5417 46.2927 13.8709 45.7066 14.457C45.1206 15.043 44.7913 15.8379 44.7913 16.6667C44.7913 17.4955 45.1206 18.2904 45.7066 18.8764C46.2927 19.4625 47.0875 19.7917 47.9163 19.7917Z",
    fill: "url(#paint0_linear_4_32433)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.583 42.7084C52.508 42.7084 42.708 52.5084 42.708 64.5834C42.708 76.6584 52.508 86.4584 64.583 86.4584C76.658 86.4584 86.458 76.6584 86.458 64.5834C86.458 52.5084 76.658 42.7084 64.583 42.7084ZM64.583 48.9584C73.208 48.9584 80.208 55.9584 80.208 64.5834C80.208 73.2084 73.208 80.2084 64.583 80.2084C55.958 80.2084 48.958 73.2084 48.958 64.5834C48.958 55.9584 55.958 48.9584 64.583 48.9584Z",
    fill: "url(#paint1_linear_4_32433)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9577 81.3751L89.4577 93.8751C90.0434 94.4608 90.8377 94.7898 91.666 94.7898C92.4943 94.7898 93.2887 94.4608 93.8744 93.8751C94.46 93.2894 94.7891 92.495 94.7891 91.6668C94.7891 90.8385 94.46 90.0441 93.8744 89.4584L81.3744 76.9584C81.0844 76.6684 80.7401 76.4384 80.3612 76.2814C79.9823 76.1245 79.5761 76.0437 79.166 76.0437C78.7559 76.0437 78.3498 76.1245 77.9709 76.2814C77.592 76.4384 77.2477 76.6684 76.9577 76.9584C76.6677 77.2484 76.4376 77.5927 76.2807 77.9716C76.1237 78.3505 76.043 78.7566 76.043 79.1668C76.043 79.5769 76.1237 79.983 76.2807 80.3619C76.4376 80.7408 76.6677 81.0851 76.9577 81.3751Z",
    fill: "url(#paint2_linear_4_32433)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_32433",
    x1: 6.30614,
    y1: 5.20838,
    x2: 107.812,
    y2: 108.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_32433",
    x1: 43.2443,
    y1: 42.7084,
    x2: 92.8171,
    y2: 93.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_32433",
    x1: 76.2728,
    y1: 76.0437,
    x2: 97.5138,
    y2: 97.7393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearch);
export default __webpack_public_path__ + "static/media/Research.b13999a5ad25abaeac4dcfa149e1b262.svg";
export { ForwardRef as ReactComponent };